import React, { useState } from "react";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import AuthLayout from "../components/admin/AuthLayout";
import VerticalForm from "../components/admin/VerticalForm";
import FormInput from "../components/admin/FormInput";
import { employeeLogin } from "../service/EmployeeLoginService";
import { useToast } from "../components/toast/ToastProvider";

const EmployeeLogin = ({ setIsAdmin }) => {
  const navigate = useNavigate();
  const toast = useToast();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [usernameError, setUsernameError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleUsernameChange = (e) => {
    setUsernameError("");
    setUsername(e.target.value);
  };

  const handlePasswordChange = (e) => {
    setPasswordError("");
    setPassword(e.target.value);
  };

  const handleLogin = async (e) => {
    e.preventDefault();

    let hasError = false;

    if (!username.trim()) {
      setUsernameError("Username is required");
      hasError = true;
    }

    if (!password.trim()) {
      setPasswordError("Password is required");
      hasError = true;
    }

    if (hasError) return;

    setLoading(true);

    try {
      const result = await employeeLogin(username, password);

      if (result.success) {
        toast("Login Successfully", "SUCCESS");
        const user = JSON.parse(localStorage.getItem("VVRHCS"));
        const token = user?.token;
        const role = user?.role;
        setIsAdmin(token !== null && token !== undefined && role === "Admin" );
        navigate("/admin");
      } else {
        toast(result.message || "Login failed", "ERROR");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout helpText="Employee Login">
      <VerticalForm onSubmit={handleLogin}>
        <FormInput
          label="Username"
          type="text"
          name="username"
          value={username}
          placeholder="Enter your Username"
          onChange={handleUsernameChange}
          errorText={usernameError}
          containerClass="mb-3"
        />
        <FormInput
          label="Password"
          type="password"
          name="password"
          value={password}
          placeholder="Enter your password"
          onChange={handlePasswordChange}
          errorText={passwordError}
          containerClass="mb-3"
        />

        <div className="text-right d-grid">
          <Button
            type="submit"
            className="btn-sm p-2"
            style={{ backgroundColor: "#10296C", color: "#fff" }}
            disabled={loading}
          >
            {loading ? "Logging In..." : "Log In"}
          </Button>
        </div>
      </VerticalForm>
    </AuthLayout>
  );
};

export default EmployeeLogin;
